import React, { Component } from "react";
import { connect } from "react-redux";

import StoreOverallForm from "./form";
import { createStoreOverall } from "../actions";

import { Page, Navbar } from "framework7-react";

// Persisted Stuff
import Form from "modules/4_final_form/PersistedForm";

// Helpers
import HasRole from "modules/5_view_helpers/HasRole";
import arrayMutators from "final-form-arrays";
import NotAuthorized from "modules/5_view_helpers/mobile/NotAuthorized";

function mapStateToProps(state) {
  return {};
}

class NewStoreOverall extends Component {
  constructor(props) {
    super(props);
    this.submitForm = this.submitForm.bind(this);
    this.successfullySubmitted = this.successfullySubmitted.bind(this);

    const createRole = HasRole(
      {
        resource_type: "Project::Qa::ActionItem",
        name: ["create", "moderator"],
      },
      true
    );

    const returnUrl = `/store/overalls`;

    this.state = {
      returnUrl: returnUrl,
      createRole,
    };
  }

  submitForm(values) {
    const {
      f7router: { app },
      project_id,
    } = this.props;

    // When clicked cancel
    this.preloader = app.preloader;
    this.preloader.show();
    const createRequest = this.props.createStoreOverall(values);
    createRequest.then(this.successfullySubmitted);
    createRequest.catch((e) => {
      this.preloader.hide();
      const data = e.response?.data;
      const result = _.join(
        _.map(data, (v, k) => `${k}:"${v}"`),
        " "
      );
      app.dialog.alert(result);
    });
  }
  successfullySubmitted() {
    const {
      f7router,
      f7router: { app },
    } = this.props;

    const { returnUrl } = this.state;

    this.preloader.hide();
    app.toast
      .create({
        icon: '<i class="material-icons">check</i>',
        text: "Created Store Overall!",
        position: "center",
        closeTimeout: 2000,
        on: {
          opened: () => {
            f7router.navigate(returnUrl);
          },
        },
      })
      .open();
  }

  render() {
    const { history } = this.props;
    const { returnUrl, createRole } = this.state;

    const barcodes = this.props.f7route.query?.barcodes ? this.props.f7route.query?.barcodes.split(",") : [];

    if (!createRole) {
      return <NotAuthorized />;
    }

    return (
      <Page>
        <Navbar title="New Store Overall" backLink />
        <Form
          component={StoreOverallForm}
          onSubmit={this.submitForm}
          mutators={{
            ...arrayMutators,
          }}
          initialValues={{
            issue_date: moment().format("YYYY-MM-DD"),
            barcodes: barcodes,
          }}
          formLabel="Create"
          cancelFunction={() => {
            history.push(returnUrl);
          }}
          {...this.props}
        />
      </Page>
    );
  }
}

export default connect(mapStateToProps, { createStoreOverall })(NewStoreOverall);
